import * as React from 'react';
export const compassSvg = React.forwardRef(function compassSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#00539B',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M25.645 16.603h-2.06l1.023-3.188 1.037 3.188Zm-.324-4.457c.554 0 .696.13.907.713l2.272 6.275h-2.024l-.494-1.508h-2.724l-.492 1.508h-1.168l2.292-6.988h1.43Zm-4.019 0h1.138l-2.196 6.989-1.73-.001-2.356-6.987 1.274-.001c.49 0 .62.122.877.914l1.364 4.394 1.629-5.308Zm-7.96 3.076.591-.87c.15-.218.181-.355.181-.508 0-.427-.38-.786-.82-.786h-.909v5.141h.504c.843 0 1.483-.449 1.483-1.5 0-.866-.412-1.33-1.03-1.477Zm.354 3.916h-2.979v-6.992h3.087c1.448 0 1.952 1.162 1.22 2.235l-.347.507c2.428 1.242 1.638 4.25-.981 4.25Zm-6.571-3.916.591-.87c.15-.218.181-.355.181-.508 0-.427-.38-.786-.819-.786h-.91v5.141h.504c.843 0 1.483-.449 1.483-1.5 0-.866-.413-1.33-1.03-1.477Zm.354 3.916H4.5v-6.992h3.088c1.447 0 1.951 1.162 1.218 2.235l-.346.507c2.428 1.242 1.638 4.25-.981 4.25Z',
      fill: '#fff',
    }),
  );
});
compassSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var compass = {
  category: 'brand',
  colorable: false,
  name: 'compass',
  svg: compassSvg,
};
